/**
* Custom Select
*/
class customSelect extends HTMLElement{
  constructor() {
    super();
    this.selectContainer = this.querySelector('.custom-dropdown');
    this.select = this.querySelector('ul, [role="radiogroup"]');
    this.initOption = this.querySelector('.default');
    this.options = this.select.querySelectorAll('li, [data-value]');

    // Ensure dropdown starts closed
    if (this.selectContainer) {
      this.selectContainer.classList.remove('open');
      const toggleContent = this.selectContainer.querySelector('.toggle-content');
      if (toggleContent) {
        toggleContent.classList.remove('open');
      }
    }

    this.options.forEach(option => option.addEventListener('click', this.toggleOptions.bind(this)));
    this.initOption.addEventListener('click', this.manageVisibility.bind(this));

    this.addEventListener('click', (event) => {
      event.stopPropagation();
    });
    document.body.addEventListener('click', (event)=> {
      if(event.target.closest('[data-type="subscribe-only"]') == null) {
        Utility.toggleElement(this.selectContainer, 'close');
        // Update aria-expanded for accessibility when closing
        const toggleButton = this.initOption;
        if (toggleButton) {
          toggleButton.setAttribute('aria-expanded', 'false');
        }
      }
    });
  }

  /**
   * Toggle custom select option
   * @param event 
   */
  toggleOptions(event){
    let _this = event.currentTarget;
    this.options.forEach(option => option.classList.remove('selected'));
    _this.classList.add('selected');
    _this.closest('.custom-dropdown').classList.add('selected');
    Utility.toggleElement(this.selectContainer, 'close');
    
    // Update aria-expanded for accessibility when closing
    const toggleButton = this.initOption;
    if (toggleButton) {
      toggleButton.setAttribute('aria-expanded', 'false');
    }
    
    if(event.pointerId == 1 && event.currentTarget.closest('cart-form') != null){
      AjaxCart.prototype.updateSellingPlan(event);
    }
    
    // Use requestAnimationFrame instead of setTimeout for better Safari compatibility
    requestAnimationFrame(() => {
      const customSelect = _this.closest('custom-select');
      const optionText = customSelect?.querySelector('.option_txt');
      
      if (optionText) {
        if (_this.closest('sortby-dropdown')) {
          optionText.innerHTML = `<span class="fw-bold me-2 d-inline-block d-xl-none">Sort By:</span> ${_this.querySelector('.option_txt').textContent}`;
        } else {
          optionText.innerHTML = _this.querySelector('.option_txt').textContent;
        }
      }
    });
  }

  /**
   * Hide/Show of custom select option
   * @param _event 
   */
    manageVisibility(_event){
      let isOpen = this.selectContainer.classList.contains('open');
      if(isOpen == false){
        document.querySelectorAll('.template-collection .custom-dropdown.open').forEach(x => x.classList.remove('open'));
        document.querySelectorAll('.template-collection .toggle-content.open').forEach(x => x.classList.remove('open'));
      }
      isOpen ? Utility.toggleElement(this.selectContainer, 'close') : Utility.toggleElement(this.selectContainer, 'open');
      
      // Update aria-expanded for accessibility
      const toggleButton = this.initOption;
      if (toggleButton) {
        const newState = !isOpen;
        toggleButton.setAttribute('aria-expanded', newState.toString());
      }
    }
}
customElements.define('custom-select', customSelect);

/**
* Tab HTML
*/
class customTabs extends HTMLElement {
    constructor() {
      super();
  
      this.tabLinks = this.querySelectorAll('.tablink');
      this.tabContainers = this.querySelectorAll('.tabcontent');
  
      this.tabLinks.forEach( link => link.addEventListener('click', this.toggleTabs.bind(this)));
    }
  
    /**
     * Escape Key Press to close drawer when focus is within the container
     *
     * @param {event} Event instance
     */
    onKeyUp(event) {
      if(event.code && event.code.toUpperCase() !== 'ESCAPE') return;
    }
  
    /**
     * Toggle Tabs on link click
     *
     * @param {event} Event instance
     */
    toggleTabs(event){
      event.preventDefault();
      event.stopPropagation();
      const currentTab = event.currentTarget;
      const tabLink = currentTab.querySelector('[data-toggle="tab"]');
      const tabContainer = document.querySelector(tabLink.dataset.tabcontent);
  
      this.openTab(currentTab, tabContainer)
    }
  
    /**
     * Open Tab Container
     *
     * @param {Node} currentTab Tab Container Open link
     * @param {Node} tabContainer Tab Container to open
     */
    openTab(currentTab, tabContainer) {
      this.tabContainers.forEach(container => {
        container.classList.remove('open');
        const linkEle = document.querySelector('.tablink a[data-toggle="tab"][data-tabcontent="#'+container.id+'"]');
        if(linkEle){
          linkEle.setAttribute('aria-expanded', false);
          if(linkEle.closest('.tablink')){ linkEle.closest('.tablink').classList.remove('open');}
        }
      });
      currentTab.classList.add('open');
      currentTab.querySelector('[data-toggle="tab"]').setAttribute('aria-expanded', true);
      tabContainer.classList.add('open');
    }
}
customElements.define("custom-tabs", customTabs);

/**
  * collaspsible Panel
  *
  * @param {element} element - Collapsible panel element
*/
class collapsiblePanel {
  constructor(element) {
    this.element = element;
    this.toggleBtn = this.element.querySelector('.panel_toggle');
    if(this.toggleBtn) this.toggleBtn.addEventListener('click', this.toggleContent.bind(this));
  }

  /**
   * Toggle Row Content
   * @param {event} event 
  */
  toggleContent(event) {
    event.preventDefault();
    const isOpen = this.element.classList.contains('open');
    isOpen ? this.hideContent() : this.showContent();
  }

  /**
   * Show panel content
   */
   showContent() {
    this.toggleBtn.setAttribute('aria-expanded', true);
    Utility.toggleElement(this.element, 'open');
    Utility.trapFocus(this.element);

    if(this.element.dataset.behaviour == 'single'){
      let siblingBlocks = this.element.parentNode.querySelectorAll('[is="collapsiblePanel"].open');
      siblingBlocks.forEach(element => {
        if(element == this.element){ return; }
        element.querySelector('.panel_toggle').click();
      });
    }
  }

  /**
   * Hide panel content
   */
  hideContent() {
    this.toggleBtn.setAttribute('aria-expanded', false);
    Utility.toggleElement(this.element, 'close');
    Utility.removeTrapFocus(this.element);
  }

  static init() {
    const collapsibleElements = document.querySelectorAll('[is="collapsiblePanel"]');
    collapsibleElements.forEach((ele) => {
      new collapsiblePanel(ele);
    });
  }
}
collapsiblePanel.init();
  

  
  